import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-[#E5E0D8] mt-24" data-testid="app-footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 py-12 flex flex-col sm:flex-row sm:items-center justify-between gap-6 text-sm text-[#8A8A8A]">
        <p>© {new Date().getFullYear()} Evervow — dating designed to end in marriage.</p>
        <nav className="flex flex-wrap gap-6">
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className="hover:text-[#1A1A1A] transition-colors duration-300"
          >
            Privacy
          </Link>
          <Link
            to="/terms"
            data-testid="footer-terms-link"
            className="hover:text-[#1A1A1A] transition-colors duration-300"
          >
            Terms
          </Link>
          <Link
            to="/delete-account"
            data-testid="footer-delete-account-link"
            className="hover:text-[#1A1A1A] transition-colors duration-300"
          >
            Delete account
          </Link>
          <a
            href="mailto:support@evervow.me"
            data-testid="footer-support-link"
            className="hover:text-[#1A1A1A] transition-colors duration-300"
          >
            support@evervow.me
          </a>
        </nav>
      </div>
    </footer>
  );
}
